<div class="job-posts placements margin-top-30px agreements top-link2">


  <div class="row">
    <div class="col-12 padding-right-0px ">
      <div class="position-fixed-mis-sm border-right2 padding-right-0px">
        <div class="card">
          <div class="card-header wh-header font-weight-normal padding-right-0px padding-bottom-0px padding-left-9px padding-top-5px background-new ">

          </div>
          <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-6 mistable-data" *canUserAccess="['HL_MI_5']">
                <a class="nav-link-hand font-size-16px margin-left-5px " [routerLink]="['/healins/latestdashboard']">
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <i class="fas fa-chart-line font-size-64px color-darkorange"></i>
                    </div>
                  </div>
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <label class="margin-bottom-0px title-text-color font-size-12px">MIS</label>
                    </div>
                  </div>

                </a>

              </div>
              <div class="col-6 mistable-data">

                <a class="nav-link-hand font-size-16px margin-left-5px " [routerLink]="['/healins/smartphonefdappointment']">
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <i class="far fa-calendar-alt color-green font-size-64px"></i>
                    </div>
                  </div>
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <label class="margin-bottom-0px title-text-color font-size-12px">My Appointments</label>
                    </div>
                  </div>

                </a>
              </div>
              <div class="col-6 mistable-data">

                <a class="nav-link-hand font-size-16px margin-left-5px " [routerLink]="['/healins/sm_doc_appts']">
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <i class="far fa-calendar-alt color-cyan font-size-64px"></i>
                    </div>
                  </div>
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <label class="margin-bottom-0px title-text-color font-size-12px">Doctor Appointments</label>
                    </div>
                  </div>

                </a>
              </div>
              <div class="col-6 mistable-data">

                <a class="nav-link-hand font-size-16px margin-left-5px ">
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <i class="far fa-question color-gray font-size-64px"></i>
                    </div>
                  </div>
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <label class="margin-bottom-0px title-text-color font-size-12px">Lab Approvals</label>
                    </div>
                  </div>

                </a>
              </div>
              <div class="col-6 mistable-data">

                <a class="nav-link-hand font-size-16px margin-left-5px ">
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <i class="far fa-question color-gray font-size-64px"></i>
                    </div>
                  </div>
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <label class="margin-bottom-0px title-text-color font-size-12px">Refund Approvals</label>
                    </div>
                  </div>

                </a>
              </div>
              <div class="col-6 mistable-data">

                <a class="nav-link-hand font-size-16px margin-left-5px ">
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <i class="far fa-question color-gray font-size-64px"></i>
                    </div>
                  </div>
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <label class="margin-bottom-0px title-text-color font-size-12px">Store Approvals</label>
                    </div>
                  </div>

                </a>
              </div>
              <div class="col-6 mistable-data">

                <a class="nav-link-hand font-size-16px margin-left-5px ">
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <i class="far fa-question color-gray font-size-64px"></i>
                    </div>
                  </div>
                  <div class="row nomargin">
                    <div class="col-12 text-align-center">
                      <label class="margin-bottom-0px title-text-color font-size-12px">Discount Approvals</label>
                    </div>
                  </div>

                </a>
              </div>

            </div>

            <div hidden class="chatsd product-chart-wrapper product-chat-width-mis agreement-chart-wrapper ps ps2 padding-top-10px padding-left-29px padding-right-29px padding-bottom-29px  " data-ps-id="dfsfsde">

              <div class="row nomargin  rowfor padding-top-5px padding-bottom-5px nav-link-hand background-dark-new" *canUserAccess="['HL_MI_5']">
                <div class="col-md-12 col-12">
                  <a class="nav-link-hand font-size-16px margin-left-5px data-color-white" [routerLink]="['/healins/latestdashboard']">MIS</a>
                </div>
              </div>
              <div class="row padding-all-10px"></div>
              <div class="row nomargin rowfor padding-top-5px padding-bottom-5px nav-link-hand background-dark-new">
                <div class="col-md-12 col-12">
                  <a class="nav-link-hand font-size-16px margin-left-5px data-color-white" [routerLink]="['/healins/smartphonefdappointment']">My Appointments</a>
                </div>
              </div>

              <div class="row border-bottom rowfor padding-top-5px padding-bottom-5px nav-link-hand background-dark-new" *canUserAccess="['HL_SP_LAB_1']">
                <div class="col-md-12 col-12">
                  <a class="nav-link-hand font-size-16px margin-left-5px">Lab Approvals</a>
                </div>
              </div>

              <div class="row border-bottom rowfor padding-top-5px padding-bottom-5px nav-link-hand background-dark-new" *canUserAccess="['HL_SP_RF_1']">
                <div class="col-md-12 col-12">
                  <a class="nav-link-hand font-size-16px margin-left-5px">Refund Approvals</a>
                </div>
              </div>

              <div class="row border-bottom rowfor padding-top-5px padding-bottom-5px nav-link-hand background-dark-new" *canUserAccess="['HL_SP_SA_1']">
                <div class="col-md-12 col-12">
                  <a class="nav-link-hand font-size-16px margin-left-5px">Store Approvals</a>
                </div>
              </div>

              <div class="row border-bottom rowfor padding-top-5px padding-bottom-5px nav-link-hand background-dark-new" *canUserAccess="['HL_SP_DA_1']">
                <div class="col-md-12 col-12">
                  <a class="nav-link-hand font-size-16px margin-left-5px">Discount Approvals</a>
                </div>
              </div>

            </div>

            <div>

            </div>

          </div>

        </div>
      </div>
    </div>
  </div>

</div>


<div class="job-posts placements agreements  margin-top-30px" hidden>
  <div class="card skillassest-form">

  </div>
  <div class="card-body padding-top padding-left-0px padding-right-10px">
    <ul class="padding-left-0px">
      <li class="">
        <ul class="padding-left-0px">
          <li class="font-size-16px color-Assign font-weight-normal"><i class="fas fa-th link6 margin-right-8em"></i>Dashboard</li>
          <li class="font-size-14 margin-top-5px margin-bottom-5px padding-left-25px" *canUserAccess="['HL_MI_5']">
            <a class=" nav-link-hand text-decoration color-data2 nav-new font-weight-normal"
               [routerLink]="['/healins/latestdashboard']">
              MIS

            </a>

          </li>

        </ul>
      </li>
    </ul>
    <ul class="padding-left-0px">
      <li class="">
        <ul class="padding-left-0px">
          <li class="font-size-16px color-Assign font-weight-normal"><i class="far fa-calendar-alt margin-right-8em"></i>Appointments</li>
          <li class="font-size-14 margin-top-5px margin-bottom-5px padding-left-25px" *canUserAccess="['HL_MI_5']">
            <a class=" nav-link-hand text-decoration color-data2 nav-new font-weight-normal">

              Appointments

            </a>

          </li>

          <li class="font-size-14 margin-top-5px margin-bottom-5px padding-left-25px" *canUserAccess="['HL_SCH_1']">
            <a class=" nav-link-hand text-decoration color-data2 nav-new font-weight-normal">
               
              All Branches Appointments


            </a>


          </li>

        </ul>
      </li>
    </ul>
  </div>

</div>




